module.exports = __webpack_public_path__ + "static/media/8_2.629418ab.png";